export default {
  user: {
    partner: {},
    finance: {},
    isLoading: false,
    userId: null,
    location: {
      error: null,
      isError: false,
      isLoading: false
    },
    email: null,
    isLoggedIn: false,
    softpull: {},
    mostPopularSortOption: null,
    discounts: [],
    visitContext: {},
    deliveryContext: {},
    favorites: [],
    headerContext: {},
    availability: {}
  },
  upgradesFlow: {
    userState: 'DISABLED',
    upgradeInformation: {
      activeTrade: {},
      activeLoan: {},
      isCustomerEligibleForUpgrade: false
    }
  },
  appSettings: {
    manageUpgradesFlow: {
      shouldShowOnVDP: false
    },
    merchWipPurchaseFlow: {
      isExperimentOn: false,
      toggleDirectDelivery: false,
      locationIds: []
    }
  },
  makeItYours: {
    currentTab: 'financing',
    hasHighNetTrade: false,
    shouldDisableFinancingTab: false,
    dropdowns: {
      loanLengthList: [],
      creditBucketList: [
        { label: 'Excellent - 780', value: 'Excellent' },
        { label: 'Good - 680', value: 'Good' },
        { label: 'Average - 630', value: 'Average' },
        { label: 'Below Average - 588', value: 'BelowAverage' }
      ],
      incomeList: [
        { label: '$20,000', value: 20000 },
        { label: '$25,000', value: 25000 },
        { label: '$30,000', value: 30000 },
        { label: '$40,000', value: 40000 },
        { label: '$50,000', value: 50000 },
        { label: '$60,000', value: 60000 },
        { label: '$70,000', value: 70000 },
        { label: '$80,000', value: 80000 },
        { label: '$90,000', value: 90000 },
        { label: '$100,000', value: 100000 },
        { label: '$120,000', value: 120000 },
        { label: '$150,000', value: 150000 },
        { label: '$200,000', value: 200000 }
      ],
      values: {
        loanLength: 72,
        creditBucket: 'Excellent',
        income: 60000
      }
    },
    sliderValues: {
      monthlyPayment: {
        min: 0,
        max: 0,
        value: 0
      },
      downPayment: {
        min: 0,
        max: 0,
        value: 0
      }
    },
    quote: {
      isLoading: false
    },
    terms: [],
    slidersInMotion: false,
    ancillaryProducts: {
      isLoading: false,
      products: {},
      selectedProducts: []
    },
    termBuckets: {},
    transport: {},
    paymentSummary: {
      hasIncludedTradeIn: false,
      estimatedMonthlyPayment: 0,
      estimatedApr: 0,
      vehiclePrice: 0,
      taxTitleReg: 0,
      cashDown: 0,
      tradeInCredit: 0,
      estimatedAmountFinanced: 0,
      transportCost: 0
    },
    thirdPartyFinancingPartner: {
      doesThirdPartyFinancingCookieExist: false,
      isCapitalOneFinancing: false,
      isDeltaCommunityFinancing: false,
      isRBGFUFinancing: false,
      isCarvanaFinancing: false
    },
    tradeInfo: {
      isLoading: false,
      error: null,
      isError: false,
      trades: []
    },
    error: null,
    isError: false,
    isInitialLoading: true,
    isSubsequentLoading: false,
    thirdPartyTerms: {}
  },
  vehicleDetails: {
    isLoading: true,
    vehicleId: null,
    header: {
      isFavorited: false
    },
    details: {},
    analytics: {},
    highlights: {},
    estimatedDelivery: {
      isLoading: false,
      error: null,
      delivery: {},
      pickup: {
        route: {
          locationId: 0
        }
      }
    },
    alertModals: {
      isLoading: false,
      purchasePending: false,
      closeAlert: false,
      vehicleSold: false,
      cancelPurchase: false,
      cancelReservation: false,
      recallStatus: []
    },
    carFax: {},
    delivery: {},
    spinner: {
      hasError: false
    }
  },
  vehiclesYouMightLike: {
    isLoading: true,
    error: null,
    isError: false,
    vehicles: []
  }
};
